import { oc } from "@orpc/contract";
import { z } from "zod";

const SupplierContactSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  title: z.string().nullable(),
  isPrimary: z.boolean(),
  apRemittance: z.boolean(),
  source: z.enum(["manual", "supplier"]),
});

const AddApRemittanceContactInputSchema = z.object({
  supplierId: z.string().uuid(),
  email: z.string().trim().toLowerCase().pipe(z.email()),
  name: z.string().trim().min(1).optional(),
});

export const supplierContactsContracts = {
  list: oc
    .input(z.object({ supplierId: z.string().uuid() }))
    .output(z.object({ contacts: z.array(SupplierContactSchema) }))
    .route({
      method: "GET",
      summary: "List supplier contacts",
      description:
        "Lists a supplier's contacts with email, phone, title, primary flag, and whether each receives AP remittance emails. Syncs the supplier's primary email into a contact first.",
    }),
  toggleApRemittance: oc
    .input(
      z.object({
        contactId: z.string().uuid(),
        apRemittance: z.boolean(),
      }),
    )
    .output(z.object({ success: z.boolean() }))
    .route({
      method: "POST",
      summary: "Set a contact as AP remittance recipient",
      description:
        "Turns AP remittance on or off for a supplier contact, controlling whether they receive payment remittance emails.",
    }),
  addApRemittanceContact: oc
    .input(AddApRemittanceContactInputSchema)
    .output(z.object({ contactId: z.string().uuid() }))
    .route({
      method: "POST",
      summary: "Add an AP remittance contact",
      description:
        "Adds an email (and optional name) as a supplier contact flagged to receive payment remittance emails, reusing an existing contact when one matches.",
    }),
} as const;
